import React, { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle, XCircle, ShieldCheck, ShieldWarning, FacebookLogo, Storefront } from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const IntegrationStatus = ({ clientId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/clients/${clientId}/integrations/status`);
        if (!cancelled) setData(res.data);
      } catch {
        if (!cancelled) setData(null);
      }
    })();
    return () => { cancelled = true; };
  }, [clientId]);

  if (!data) return null;
  const fb = data.facebook || {};
  const sh = data.shopify || {};

  const Pill = ({ ok, label, sub, icon: Icon, level }) => {
    const bg = ok ? "#16A34A22" : "#52525B33";
    const color = ok ? "#86EFAC" : "#A1A1AA";
    return (
      <div className="flex items-center gap-2 px-2.5 py-1.5 rounded" style={{ background: bg, color }} data-testid={`integration-${label.toLowerCase()}`}>
        <Icon size={14} weight="bold" />
        <div className="flex flex-col">
          <span className="text-[10px] font-semibold leading-tight">{label}</span>
          <span className="text-[9px] opacity-80 leading-tight">{sub}</span>
        </div>
        {ok && level && (
          <span
            className="ml-1 px-1.5 py-0.5 rounded text-[8px] font-bold"
            style={{
              background: level === "write_enabled" ? "#16A34A" : level === "read_only" ? "#EAB308" : "#52525B",
              color: level === "read_only" ? "#111" : "#fff",
            }}
            title={level === "write_enabled" ? "Pause/resume/budget actions enabled" : "Read-only — reconnect with full scope to enable actions"}
          >
            {level === "write_enabled" ? "WRITE" : "READ-ONLY"}
          </span>
        )}
        {ok ? <CheckCircle size={12} weight="fill" /> : <XCircle size={12} weight="fill" />}
      </div>
    );
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="integration-status-row">
      <Pill
        ok={fb.connected}
        label="Meta"
        sub={fb.connected ? `${fb.graph_api_version}` : "Not connected"}
        icon={FacebookLogo}
        level={fb.permission_level}
      />
      <Pill
        ok={sh.connected}
        label="Shopify"
        sub={sh.connected ? `${sh.store_count} store${sh.store_count > 1 ? "s" : ""}` : "Not connected"}
        icon={Storefront}
      />
      {fb.connected && fb.permission_level === "read_only" && (
        <div className="text-[10px] text-[#FCD34D] flex items-center gap-1 px-2">
          <ShieldWarning size={12} />
          Reconnect Meta to enable Pause / Resume / Budget actions
        </div>
      )}
    </div>
  );
};

export default IntegrationStatus;
